export const partnerFeatures = [
  { label: "Accepts Returns", value: "featuresReturns" },
  { label: "Shipout service", value: "featuresShipout" },
  { label: "Payment on Delivery", value: "featuresCod" },
];
